import apiClient from '../services/apiClient'

export const getAllUser = async () => {
    return (await apiClient.get('/users')).data
}

export const resetPassword = async (pseudo: string) => {
    return await apiClient.post('/users/reset-password', { pseudo })
}
